// import { useState } from 'react';
import * as React from 'react'
// import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import /* Select, */ { SelectChangeEvent } from '@mui/material/Select';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { switchAccount } from '../../store/authSlice';
import { /* InputLabel, */ Avatar, Typography, Menu, MenuItem, Tooltip, IconButton, Button } from '@mui/material';
import { StyledIconButton } from './SwitchAccount.styles';
import LoopIcon from '@mui/icons-material/Loop';
import PersonOutlineTwoToneIcon from '@mui/icons-material/PersonOutlineTwoTone';
import BusinessCenterTwoToneIcon from '@mui/icons-material/BusinessCenterTwoTone';

/**
 * Component to switch user account.
 */
interface Props {
	handleProfileMenuOpen: (value:any)=> void;
}

const SwitchAccount: React.FC<Props> = ({handleProfileMenuOpen}) => {
	const { user, selectedAccount } = useAppSelector(state => state.auth);
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	// const [activeAccountId] = useState(selectedAccount._id);
	const navigate = useNavigate();

	const dispatch = useAppDispatch();

	/**
	 * Method to handle account change.
	 */
	// const handleAccountChange = (event: SelectChangeEvent) => {
	//     dispatch(switchAccount({ accountId: event.target.value, userId: user._id }));
	//     navigate('/home');
	// };

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (event: SelectChangeEvent | React.MouseEvent<HTMLElement>) => {
		let button = event.target as HTMLButtonElement;
		let selectId = button.getAttribute('value')

		if (selectId) {
			dispatch(switchAccount({ accountId: selectId, userId: user._id }));
			navigate('/home');
		}

		setAnchorEl(null);
	};

	// Accounts dropdown options.
	const accountOptions = user?.accounts?.map(({ _id, name, logo }, i) => (
		<MenuItem
			key={i}
			value={_id}
		>
			<Avatar
				alt={name}
				imgProps={{ "referrerPolicy": 'no-referrer' }}
				src={`${logo}`}
			/>
			{name}
		</MenuItem>
	));

	return (
		<>
			<IconButton
				onClick={handleClick}
				aria-label="account of current user"
				aria-controls={''}
				aria-haspopup="true"
				style={{ color: '#545454', backgroundColor: '#fff', border: 'none', height: 39.5, width: 39.5, marginTop: -5, marginRight: 5 }}
				size='small'
			>
				<BusinessCenterTwoToneIcon style={{ fontSize: 24 }} />
			</IconButton>

			<IconButton
				onClick={(e)=> handleProfileMenuOpen(e.currentTarget)}
				aria-label="account of current user"
				aria-controls={''}
				aria-haspopup="true"
				style={{ color: '#545454', backgroundColor: '#fff', border: 'none', height: 39.5, width: 39.5, marginTop: -5, marginRight: 5 }}
				size='small'
			>
				<Avatar style={{fontSize:14,height:30,width:30}}
                        alt={user?.name}
                        imgProps={{ "referrerPolicy": 'no-referrer' }}
                        src={`${user?.profilePic}`}/>
			</IconButton>
			
			<Menu
				anchorEl={anchorEl}
				id="switchAccountMenu"
				open={open}
				onClose={handleClose}
				onClick={handleClose}
				PaperProps={{
					elevation: 0,
					sx: {
						overflow: 'visible',
						filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
						mt: 1.5,
						'& ul': {
							overflowY: 'auto',
							maxHeight: '25vh',
							'& li': { borderBottom: '1px solid rgb(240, 240, 240)' }
						},
						'& .MuiAvatar-root': {
							width: 32,
							height: 32,
							ml: -0.5,
							mr: 1,
						},
						'&:before': {
							content: '""',
							display: 'block',
							position: 'absolute',
							top: 0,
							right: 14,
							width: 10,
							height: 10,
							bgcolor: 'background.paper',
							transform: 'translateY(-50%) rotate(45deg)',
							zIndex: 0,
						},
					},
				}}
				transformOrigin={{ horizontal: 'right', vertical: 'top' }}
				anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			>
				{accountOptions}
			</Menu>
		</>
	);
}

export default SwitchAccount;
